import React, { useState, useEffect } from 'react';

import { getPosts } from './actions/posts';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { FormPlant, FormTag, Post, Form, FormBenefit, FormPartner } from './components/index'
import { useAuth0 } from "@auth0/auth0-react";
// import FormBenefit from './components/FormBenefit';

const Edit: React.FC = (props) => {
    const [currentId, setCurrentId] = useState(null);
    const [currentTagId, setCurrentTagId] = useState(null);
    const [currentPlantId, setCurrentPlantId] = useState(null);

    const dispatch = useDispatch();

    const posts = useSelector((state: any) => state.posts)
    const { loginWithRedirect, logout, isAuthenticated } = useAuth0();

    const [active, setActive] = useState(1);

    useEffect(() => {
        dispatch(getPosts())
    }, [currentId, dispatch])


    //A terme, faire un seul formulaire, dynamique avec ces infos la.
    const tabItems = [
        {
            id: 1,
            title: 'CRUD îlot',
            // icon: 'tabitem__icon fas fa-child',
            // content: 'step 1 content',
        },
        {
            id: 2,
            title: 'CRUD Tags',
        },
        {
            id: 3,
            title: 'CRUD Plants',
        },
        {
            id: 4,
            title: 'CRUD Benefits',
        },
        {
            id: 5,
            title: 'CRUD Partners',
        }
    ];

    return (
        <>
        <div className="background-edit _h-full">

            <div className="_w-full _flex _justify-center _items-center _pt-sm">
                <button disabled={isAuthenticated} onClick={() => loginWithRedirect()} className={` ${isAuthenticated ? '_bg-gray hover:_bg-gray _cursor-not-allowed' : '_bg-green hover:_bg-darkengreen' } _ml-sm  _rounded-md  _text-white _font-bold _py-xs _px-sm _rounded-lg`}>
                    Se connecter
                </button>
                <button disabled={!isAuthenticated} onClick={() => logout()} className={` ${isAuthenticated ? '_bg-warning hover:_bg-darkenwarning' : '_bg-gray hover:_bg-gray _cursor-not-allowed' } _ml-sm  _rounded-md  _text-white _font-bold _py-xs _px-sm _rounded-lg`}>
                    Se déconnecter
                </button>

            </div>
            {/* <button onClick={() => loginWithRedirect()}>Log In</button> */}
            {isAuthenticated && (
                <div className="_flex _p-md _justify-center  sm:_flex-col _h-full background-edit _overflow-hidden">
                <section className="_w-1/2  _justify-center _relative _mr-sm sm:_w-full height-lab sm:_mb-md _overflow-auto">
                        <nav>
                            <ul className="_bg-white _rounded-card _mb-sm _flex _items-center _justify-around _overflow-hidden" style={{ height: '74px' }}>
                                {tabItems.map(({ id, title }) => (
                                    <li className="_h-full _w-full" onClick={() => setActive(id)}>
                                        <div className="_text-gray-600 hover:_bg-gray _h-full _w-full _flex _justify-center _items-center _cursor-pointer">{title}</div>
                                    </li>
                                ))}
                            </ul>
                        </nav>
                        {active === 1 && (
                            <Form currentId={currentId} setCurrentId={setCurrentId}/>
                        )}
                        {active === 2 && (
                            <FormTag currentTagId={currentTagId} setCurrentTagId={setCurrentTagId}/>
                            // <Form currentId={currentId} setCurrentId={setCurrentId}/>
                        )}
                        {active === 3 && (
                            <FormPlant currentPlantId={currentPlantId} setCurrentPlantId={setCurrentPlantId}/>
                            // <Form currentId={currentId} setCurrentId={setCurrentId}/>
                        )}
                        {active === 4 && (
                            <FormBenefit />
                            // <Form currentId={currentId} setCurrentId={setCurrentId}/>
                        )}
                        {active === 5 && (
                            <FormPartner />
                            // <Form currentId={currentId} setCurrentId={setCurrentId}/>
                        )}
                        
                </section>
                <section className="height-lab _w-1/2  _justify-center _flex _flex-wrap sm:_w-full _overflow-auto">
                    {posts.map((post, i) => {
                    // return <SwiperSlide onClick={ (e) => setIsDetails(!isDetails) } key={i}><Post isForm={isForm} setCurrentId={setCurrentId} isDetails={isDetails} key={post._id} post={post} /></SwiperSlide>
                        return <Post isForm={true} setCurrentId={setCurrentId} key={post._id} post={post} />
                    })}
                    {/* <PostsList slidePerPage={3} sliderDirection="vertical" isForm={true} setCurrentId={setCurrentId}/> */}
                    {/* {posts.map((post, i) => (
                        <Post isForm={true} key={post._id} post={post} setCurrentId={setCurrentId} />
                    ))} */}
                </section>
                
                    </div>
                    
                )}
        </div>
                

        </>
    );
};

export default Edit;



